import React ,{ useState } from 'react'
import axios from 'axios'
import {
  Grid, List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup, BottomNavigation, BottomNavigationAction,
  TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal, Pagination, TextField, Tabs, Tab
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { useRedirect } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import globalConfig from '../../utils/globalConfig'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
// import OrderFilters from './OrderFilters'
import legolasApi from '../../api/legolas'
import { useNavigate, useLocation } from 'react-router-dom'
import ChannelDropDown from '../common/ChannelDropDown'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import CircularProgress from "@mui/material/CircularProgress";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function OrderList() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [columnsOpen, setColumnsOpen] = React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [totalCount, setTotalcount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [searchString, setSearchstring] = React.useState('')
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: 'orderId', label: 'ID' }, { id: 'customer_email', label: 'Email' }, { id: 'mobile', label: 'Phone No' }, { id: 'createdAt', label: 'Purchase Date' },
    { id: 'grandTotal', label: 'Grand Total' }, { id: 'status', label: 'Status' },
    { id: 'shipment_status', label: 'Shipment Status' }, { id: 'synced_to_vinculum', label: 'Vinculum Sync Status' },
    { id: 'pay_method', label: 'Payment Method' }, { id: 'order_source', label: 'Order Source' },
    { id: 'delivery_method', label: 'Delivery Type ' },


  ])
  const [openFilters, setOpenFilters] = React.useState(false)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [filterArray, setFilterArray] = React.useState([])
  const [exportFormat, setExportFormat] = useState('csv');
  const [selected, setSelected] = React.useState([]);
  const [filterValue, setFilterValue] = React.useState('');
  const [selectDate, setSelectDate] = React.useState({ fromDate: null, toDate: null });
  const [allTableHeaders, setAllTableHeaders] = React.useState([
    {id: 'order_id', label: 'ID', checked: true}, 
    {id: 'email', label: 'Email', checked: true}, 
    { id: 'mobile', label: 'Phone No', checked: true },
    { id: 'createdAt', label: 'Purchase Date', checked: true },
    { id: 'grandTotal', label: 'Grand Total', checked: true },
    { id: 'order_status', label: 'Shipment ', checked: true },
    { id: 'synced_to_vinculum', label: 'Vinculum Sync', checked: true },
    // { id: 'one_day_delivery_charge', label: 'Next Day Delivery', checked: true },
    { id: 'delivery_method', label: 'Delivery Type ', checked: true },
    { id: 'pay_method', label: 'Payment Method', checked: true },
    { id: 'order_source', label: 'Order Source', checked: true },
    { id: 'isBundled', label: 'Bundled', checked: true },
    { id: 'isDiscounted', label: 'addlDisc', checked: true },
    { id: 'channelName', label: 'Channel', checked: true },
    { id: 'is_gift_product', label: 'Gift', checked: true }

  ])



  const [orderStatus, setOrderStatus] = React.useState(
    {
      1: 'PENDING',
      2: 'PROCESSING',
      3: 'ORDER SHIPPED',
      4: 'CLOSED',
      5: 'CANCELLED',
      6: 'DRAFT',
      7: 'DRAFT_INVALIDATED',
      8: 'DELIVERED'
    }
  )

  const [paymentSource, setPaymentSource] = React.useState(
    {
      1: 'COD',
      2: 'DEBIT/CREDIT CARD',
      3: 'APPLE',
      4: 'MADA',
      5: 'TAMARA',
      6: 'TABBY'
    }
  )
  const [orderSource, setOrderSource] = React.useState(
    {
      1: 'WEB',
      2: 'APP_ANDROID',
      3: 'APP_IOS',
      //4: 'AMAZON',
      5: 'M_WEB',
      6: 'ADMIN'
    }
  )

  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const userid = user.id;
  const redirect = useRedirect()
  const navigate = useNavigate()
  const [channelData, setChannelData] = React.useState([]);
  const [channelFilterArray, setChannelFilterArray] = React.useState([])
  const [loading, setLoading] = React.useState(false);
  const [statusFilter, setStatusFilter] = React.useState([]);
  const { state } = useLocation()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const searchParams =
    new URLSearchParams(location.search);

  const statusFromUrl = searchParams.get('status');
  const orderSourceFromUrl = searchParams.get('orderSource');
  const payMethodFromUrl = searchParams.get('payMethod');
  const deliveryMethodFromUrl = searchParams.get('deliveryMethod');
  const searchFromUrl = searchParams.get('search');
  const fromDateFromUrl = searchParams.get('fromDate');
  const toDateFromUrl = searchParams.get('toDate');

  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
        //setChannelData(res.data.data);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  }


const getSearchParams = () => {
  const params = new URLSearchParams(location.search);

  return {
    statusFromUrl: params.get('status'),
    orderSourceFromUrl: params.get('orderSource'),
    payMethodFromUrl: params.get('payMethod'),

    // IMPORTANT
    deliveryMethodFromUrl:
      params.get('deliveryMethod') ||
      params.get('delivery_method'),

    searchFromUrl: params.get('search'),
    fromDateFromUrl: params.get('fromDate'),
    toDateFromUrl: params.get('toDate'),
  };
};

  React.useEffect(() => {

  const params = new URLSearchParams(location.search);

  const search = params.get('search') || '';

  setSearchstring(search);

}, [location.search]);

 React.useEffect(() => {

  getChannel();

  const {
    statusFromUrl,
    orderSourceFromUrl,
    payMethodFromUrl,
    deliveryMethodFromUrl,
    searchFromUrl,
    fromDateFromUrl,
    toDateFromUrl
  } = getSearchParams();

  const filters = [];

  if (statusFromUrl && !['6', '7'].includes(statusFromUrl)) {
    filters.push(`status:${statusFromUrl}`);
  }

  if (orderSourceFromUrl) {
    filters.push(`order_source:${orderSourceFromUrl}`);
  }

  if (payMethodFromUrl) {
    filters.push(`pay_method:${payMethodFromUrl}`);
  }

  if (deliveryMethodFromUrl) {
    filters.push(`delivery_method:${deliveryMethodFromUrl}`);
  }

  if (searchFromUrl) {
    filters.push(`searchData:${searchFromUrl}`);
  }

  setFilterArray(filters);


 const parsedFromDate =
    fromDateFromUrl
      ? moment(fromDateFromUrl, 'YYYY-MM-DD').startOf('day').toDate()
      : null;

  const parsedToDate =
    toDateFromUrl
      ? moment(toDateFromUrl, 'YYYY-MM-DD').endOf('day').toDate()
      : null;

  setSelectDate({
    fromDate: parsedFromDate,
    toDate: parsedToDate
  });
}, [location.search]);

React.useEffect(() => {

  const {
    statusFromUrl,
    orderSourceFromUrl,
    payMethodFromUrl,
    deliveryMethodFromUrl,
    searchFromUrl
  } = getSearchParams();

  const filterQuery = {

    searchData: searchFromUrl || '',

    status:
      ['6', '7'].includes(statusFromUrl)
        ? ['6', '7']
        : statusFromUrl
          ? [statusFromUrl]
          : ['NOT_DRAFT'],

    order_source:
      orderSourceFromUrl
        ? [orderSourceFromUrl]
        : [],

    pay_method:
      payMethodFromUrl
        ? [payMethodFromUrl]
        : [],

    delivery_method:
      deliveryMethodFromUrl
        ? [deliveryMethodFromUrl]
        : [],

    channel:
      channelFilterArray.length > 0
        ? channelFilterArray
        : [...userChannels],

    fromDate:
      selectDate?.fromDate
        ? moment(selectDate.fromDate).format('YYYY-MM-DD')
        : null,

    toDate:
      selectDate?.toDate
        ? moment(selectDate.toDate).format('YYYY-MM-DD')
        : null,
  };

  console.log("FILTER QUERY =>", filterQuery);

  setLoading(true);

  axios.post(
    `${legolasApi.url}/orders/list`,
    filterQuery
  )
  .then((res) => {
    setListData(res.data.data.orders);
    setTotalcount(res.data.data.count);
  })
  .catch((err) => {
    console.log(err);
  })
  .finally(() => {
    setLoading(false);
  });

}, [
  location.search,
  channelFilterArray,
  selectDate
]);
  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleColumnClick = (e) => {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  function findChecked(headerId, headerArr) {
    let checked = false
    console.log('headerId :', headerId)
    console.log('headerArr: ', headerArr)
    for (let i = 0; i < headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['id'] === headerId) {
        checked = true
        break
      }
    }
    return checked
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }

  function selectHeader(headerId, headerLabel, checked) {
    const headerObj = { "id": headerId, "label": headerLabel, "checked": checked }
    // console.log("headerObj", headerObj);
    // console.log("checked", checked);
    // const currentSelected = selectedHeaders
    // const foundHeader = currentSelected.find(header => header.id == headerId)
    const totalHeaders = [...allTableHeaders]
    const foundAllHeader = totalHeaders.find(header => header.id == headerId)
    foundAllHeader.checked = checked

    setColumnsOpen(false)
    // setSelectedHeaders(currentSelected)
    setAllTableHeaders(totalHeaders)
  }

  function resetTableHeaders() {
    const totalHeaders = [
      { id: 'order_id', label: 'ID', checked: true },
      { id: 'email', label: 'Email', checked: true },
      { id: 'mobile', label: 'Phone No', checked: true },
      { id: 'createdAt', label: 'Purchase Date', checked: true },
      { id: 'grandTotal', label: 'Grand Total', checked: true },
      { id: 'status', label: ' Shipment Status', checked: true },
      { id: 'synced_to_vinculum', label: 'Vinculum Sync Status', checked: true },
      { id: 'pay_method', label: 'Payment Method', checked: true },
      { id: 'order_source', label: 'Order Source', checked: true },
      { id: 'isBundled', label: 'Bundled', checked: true },
      { id: 'isDiscounted', label: 'addlDisc', checked: true },
      { id: 'channelName', label: 'Channel', checked: true },
      { id: 'is_gift_product', label: 'Applied Gift', checked: true },
      // { id: 'one_day_delivery_charge', label: 'Next Day Delivery', checked: true },
      { id: 'delivery_method', label: 'Delivery Type ', checked: true },
    ]
    setAllTableHeaders(totalHeaders)
  }


  const buildFilterPayload = () => {

    const selectedChannels =
      channelFilterArray && channelFilterArray.length > 0
        ? channelFilterArray.filter(ch => userChannels.includes(ch))
        : userChannels;

    // applied shipment status filter
    const appliedStatus = filterArray
      .filter(f => f.startsWith('status:'))
      .map(f => f.split(':')[1]);

    let finalStatus = [];

    // Draft tab
    if (statusFilter[0] === "7") {

      // if shipment filter selected inside draft
      if (appliedStatus.length > 0) {

        finalStatus = appliedStatus;

      } else {

        // default draft statuses
        finalStatus = ["6", "7"];
      }

    } else {

      // All Orders tab

      if (appliedStatus.length > 0) {

        finalStatus = appliedStatus;

      } else {

        // exclude drafts
        finalStatus = ["NOT_DRAFT"];
      }
    }

    return {
      source: "admin",

      // searchData:
      //   filterArray.find(f => f.startsWith('searchData:'))
      //     ?.split(':')[1] || null,
      searchData: searchString?.trim() || null,
      status: finalStatus,

      order_source: filterArray
        .filter(f => f.startsWith('order_source:'))
        .map(f => f.split(':')[1]),

      pay_method: filterArray
        .filter(f => f.startsWith('pay_method:'))
        .map(f => f.split(':')[1]),

      delivery_method: filterArray
        .filter(f => f.startsWith('delivery_method:'))
        .map(f => f.split(':')[1]),

      channel: selectedChannels,

      fromDate: selectDate.fromDate
        ? moment(selectDate.fromDate).format('YYYY-MM-DD')
        : null,

      toDate: selectDate.toDate
        ? moment(selectDate.toDate).format('YYYY-MM-DD')
        : null,
    };
  };
  const handleSearchChange = (value) => {
    setSearchstring(value);

    if (!value || value.trim() === "") {
      const params = new URLSearchParams();

      if (statusFilter[0]) {
        params.set("status", statusFilter[0]);
      }

      navigate(`/orders${params.toString() ? `?${params.toString()}` : ""}`);

      const payload = buildFilterPayload();
      payload.searchData = null;

      axios.post(`${legolasApi.url}/orders/list`, payload)
        .then((res) => {
          setListData(res.data.data.orders);
          setTotalcount(res.data.data.count);
        })
        .catch((error) => console.log('Error:', error));
    }
  };

  const handleSearch = () => {
    const params = new URLSearchParams(location.search);
    if (searchString && searchString.trim() !== '') {
      params.set("search", searchString);
    } else {
      params.delete("search");
    }
    if (['6', '7'].includes(statusFromUrl)) {
      params.set("status", statusFromUrl);
    }
    // URL
    navigate(`/orders?${params.toString()}`);
  };

  const handleFilters = (
    field,
    value,
    isSubmitCall = false
  ) => {

    let newFilterArray = [...filterArray];
    let newChannelFilterArray = [...channelFilterArray];
    let newDateRange = { ...selectDate };

    // SEARCH
    if (field === 'searchData') {

      newFilterArray =
        newFilterArray.filter(
          f => !f.startsWith('searchData:')
        );

      if (value && value.trim() !== '') {

        newFilterArray.push(
          `searchData:${value}`
        );
      }
    }

    // CHANNEL
    if (field === 'channel') {

      if (!value || value.length === 0) {

        newChannelFilterArray = [...userChannels];

      } else if (Array.isArray(value)) {

        newChannelFilterArray =
          value.map(String);

      } else {

        newChannelFilterArray =
          [String(value)];
      }

      setChannelFilterArray(
        newChannelFilterArray
      );
    }

    // OBJECT FILTERS
    if (
      typeof field === 'object' &&
      !Array.isArray(field)
    ) {

      const {
        status,
        order_source,
        pay_method
      } = field;

      if (status) {

        newFilterArray =
          newFilterArray.filter(
            f => !f.startsWith('status:')
          );

        newFilterArray.push(
          `status:${status}`
        );
      }

      if (order_source) {

        newFilterArray =
          newFilterArray.filter(
            f => !f.startsWith('order_source:')
          );

        newFilterArray.push(
          `order_source:${order_source}`
        );
      }

      if (pay_method) {

        newFilterArray =
          newFilterArray.filter(
            f => !f.startsWith('pay_method:')
          );

        newFilterArray.push(
          `pay_method:${pay_method}`
        );
      }
    }

    // SINGLE FILTER
    else if (
      typeof field === 'string' &&
      field !== 'searchData' &&
      field !== 'channel'
    ) {

      newFilterArray =
        newFilterArray.filter(
          f => !f.startsWith(`${field}:`)
        );

      if (
        value !== null &&
        value !== undefined &&
        value !== ''
      ) {

        newFilterArray.push(
          `${field}:${value}`
        );
      }
    }

    // ARRAY FILTERS
    else if (Array.isArray(field)) {

      const filterKeys =
        field.map(f => f.key);

      newFilterArray =
        newFilterArray.filter(existing => {

          return !filterKeys.some(
            key =>
              existing.startsWith(`${key}:`)
          );
        });

      field.forEach(f => {

        const { key, value } = f;

        if (
          value !== null &&
          value !== undefined &&
          value !== ''
        ) {

          newFilterArray.push(
            `${key}:${value}`
          );
        }
      });
    }

    // DATES
    if (field === 'fromDate') {

      newDateRange.fromDate = value;
      setSelectDate(newDateRange);

    } else if (field === 'toDate') {

      newDateRange.toDate = value;
      setSelectDate(newDateRange);
    }

    const updatedFilterArray = [...newFilterArray];

    setFilterArray(updatedFilterArray);

    // -------------------------
    // FILTER EXTRACTION
    // -------------------------

    const statusFromFilters =
      updatedFilterArray
        .filter(f =>
          f.startsWith('status:')
        )
        .map(f => f.split(':')[1]);

    const orderSourceFilters =
      updatedFilterArray
        .filter(f =>
          f.startsWith('order_source:')
        )
        .map(f => f.split(':')[1]);

    const payMethodFilters =
      updatedFilterArray
        .filter(f =>
          f.startsWith('pay_method:')
        )
        .map(f => f.split(':')[1]);

    const deliveryMethodFilters =
      updatedFilterArray
        .filter(f => f.startsWith('delivery_method:'))
        .map(f => f.replace('delivery_method:', ''))
        .filter(value => value !== '');
    const searchData =
      updatedFilterArray
        .find(f =>
          f.startsWith('searchData:')
        )
        ?.split(':')[1] || '';

    // -------------------------
    // URL UPDATE
    // -------------------------

    const params = new URLSearchParams();

    if (statusFromFilters.length > 0) {

      params.set(
        'status',
        statusFromFilters[0]
      );
    }

    if (orderSourceFilters.length > 0) {

      params.set(
        'orderSource',
        orderSourceFilters[0]
      );
    }

    if (payMethodFilters.length > 0) {

      params.set(
        'payMethod',
        payMethodFilters[0]
      );
    }

    if (deliveryMethodFilters.length > 0) {

      params.set(
        'deliveryMethod',
        deliveryMethodFilters[0]
      );
    }

    if (searchData) {

      params.set(
        'search',
        searchData
      );
    }

    if (newDateRange.fromDate) {

      params.set(
        'fromDate',
        moment(
          newDateRange.fromDate
        ).format('YYYY-MM-DD')
      );
    }

    if (newDateRange.toDate) {

      params.set(
        'toDate',
        moment(
          newDateRange.toDate
        ).format('YYYY-MM-DD')
      );
    }

    navigate(
      `/orders${params.toString()
        ? `?${params.toString()}`
        : ''
      }`,
      {
        replace: true
      }
    );

    // -------------------------
    // API PAYLOAD
    // -------------------------

    const filterQuery = {

      searchData,

      status:
        statusFromFilters.length > 0
          ? statusFromFilters
          : ["NOT_DRAFT"],

      order_source:
        orderSourceFilters,

      pay_method:
        payMethodFilters,

      delivery_method:
        deliveryMethodFilters,

      channel:
        newChannelFilterArray.length > 0
          ? newChannelFilterArray.filter(
            ch =>
              userChannels.includes(ch)
          )
          : [...userChannels],

      fromDate:
        newDateRange.fromDate
          ? moment(
            newDateRange.fromDate
          ).format('YYYY-MM-DD')
          : null,

      toDate:
        newDateRange.toDate
          ? moment(
            newDateRange.toDate
          ).format('YYYY-MM-DD')
          : null,
    };

    console.log(
      "FINAL FILTER QUERY =>",
      filterQuery
    );

    setLoading(true);

    axios.post(
      `${legolasApi.url}/orders/list`,
      filterQuery
    )
      .then((res) => {

        setListData(
          res.data.data.orders
        );

        setTotalcount(
          res.data.data.count
        );

        setOpenFilters(false);
      })
      .catch((err) => {

        console.log(
          'Error in getting orders: ',
          err
        );
      })
      .finally(() => {

        setLoading(false);
      });
  };

  const handleGridColumns = (header) => {
    selectHeader(header.id, header.label, !header.checked)
  }

  const handleEditClick = (order) => {

    navigate(
      `/orders/${order.order_id}${location.search}`,
      {
        state: {
          data: order
        }
      }
    );
  };

  const clearFilterArray = (field) => {
    setFilterArray(filterArray.filter(filter => !filter.startsWith(`${field}:`)));
    handleFilters(field, '');
  }

  const handlePagination = async (event, value) => {
    setCurrentPage(value);
    setLoading(true);

    try {
      const payload = buildFilterPayload();
      const res = await axios.post(
        `${legolasApi.url}/orders/list?offset=${value - 1}`,
        payload
      );

      setListData(res.data.data.orders);
      setTotalcount(res.data.data.count);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpenFilters(false);
  };

  const handleOrderCreate = () => {
    const link = `/orders/order-create`
    navigate(link, {})
  }

  const handleFromDateChange = (date) => {
    setSelectDate((prev) => ({ ...prev, fromDate: date }));
    handleFilters('fromDate', date);
  };

  const handleToDateChange = (date) => {
    setSelectDate((prev) => ({ ...prev, toDate: date }));
    handleFilters('toDate', date);
  };

  const fetchAllData = async (filterQuery) => {
    // Adjust this function to fetch all the data you need
    try {
      const res = await axios.post(`${legolasApi.url}/orders/list?limit=20000`, filterQuery);
      return res.data.data.orders;
    } catch (error) {
      console.error('Error fetching all data: ', error);
      return [];
    }
  };
  const escapeXML = (unsafe) => {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  };

  const handleExport = async () => {
    setAnchorEl(null);

    try {
      const payload = {
        ...buildFilterPayload(),
        searchData: searchString && searchString.trim() !== "" ? searchString.trim() : null,
      };
      const allData = await fetchAllData(payload);

      if (exportFormat === 'csv') {
        exportToCSV(allTableHeaders.filter(h => h.checked), allData);
      } else if (exportFormat === 'excel') {
        exportToXML(allTableHeaders.filter(h => h.checked), allData);
      }
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  const exportToCSV = (headers, data, fileName = 'data.csv') => {
    const csvRows = [];
    // Add headers to CSV
    const headerRow = headers.map(header => header.label).join(',');
    csvRows.push(headerRow);
    // Add data to CSV
    data.forEach(row => {
      const rowValues = headers.map(header => {
        let value = '';
        // if (header.id === 'one_day_delivery_charge') { value = Number(row[header.id]) > 0 ? 'True' : 'False';
        if (header.id === 'delivery_method') {
          if (row[header.id] === 'next_day_delivery') {
            value = 'NDD';
          } else if (row[header.id] === 'standard') {
            value = 'SD';
          } else if (row[header.id] === 'store_pickup') {
            value = 'SP';
          } else {
            value = '';
          }
        } else if (header.id === 'isDiscounted') {
          value = Number(row[header.id]) === 1 ? 'True' : 'False';
        } else {
          value = row[header.id] ?? '';
        }

        return `"${value}"`;
      });
      csvRows.push(rowValues.join(','));
    });
    // Create a blob from the CSV string and trigger download
    const csvString = csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const exportToXML = (headers, data, fileName = 'data.xml') => {
    let xmlString = '<?xml version="1.0" encoding="UTF-8"?>\n<data>\n';
    data.forEach(row => {
      xmlString += '  <row>\n';
      headers.forEach(header => {
        let value = '';
        // if (header.id === 'one_day_delivery_charge') {
        //   value = Number(row[header.id]) > 0 ? 'True' : 'False';
        if (header.id === 'delivery_method') {
          if (row[header.id] === 'next_day_delivery') {
            value = 'NDD';
          } else if (row[header.id] === 'standard') {
            value = 'SD';
          } else if (row[header.id] === 'store_pickup') {
            value = 'SP';
          } else {
            value = '';
          }
        } else {
          value = row[header.id] !== undefined && row[header.id] !== null ? escapeXML(row[header.id].toString()) : '';
        }

        xmlString += `    <${header.id}>${value}</${header.id}>\n`;
      });
      xmlString += '  </row>\n';
    });
    xmlString += '</data>';
    // Create a blob from the XML string and trigger download
    const blob = new Blob([xmlString], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const allOrderStatuses = {
    1: 'PENDING',
    2: 'PROCESSING',
    3: 'ORDER SHIPPED',
    4: 'CLOSED',
    5: 'CANCELLED',
    8: 'DELIVERED'
  };

  const OrderFilters = () => {
    const { handleSubmit, control, reset, getValues } = useForm({
      defaultValues: {
        userId: null,
        status: '',
        orderSource: '',
        payMethod: '',
        delivery_method: '',

      }
    })

    const handleResetFilters = () => {
      reset({
        userId: null,
        status: '',
        orderSource: '',
        payMethod: '',
        delivery_method: '',
      });
    };

    const onSubmit = (data) => {
      const filledValues = Object.values(data).filter(value => value !== '');

      if (filledValues.length >= 1) {

        console.log("Data:", data);

        const {
          status,
          orderSource,
          payMethod,
          delivery_method
        } = data;

        const filters = [];

        if (status) {

          filters.push({ key: 'status', value: status });

          // AUTO TAB SWITCH FIX

          // Draft related
          if (['6', '7'].includes(status)) {

            setStatusFilter(['7']);

            const params = new URLSearchParams();

            if (searchString) {
              params.set("search", searchString);
            }

            params.set("status", "7");

            navigate(`/orders?${params.toString()}`);

          } else {

            // All Orders
            setStatusFilter([]);

            const params = new URLSearchParams();

            if (searchString) {
              params.set("search", searchString);
            }

            navigate(`/orders${params.toString() ? `?${params.toString()}` : ""}`);
          }
        }

        if (orderSource) {
          filters.push({ key: 'order_source', value: orderSource });
        }

        if (payMethod) {
          filters.push({ key: 'pay_method', value: payMethod });
        }

        if (delivery_method !== '') {
          filters.push({
            key: 'delivery_method',
            value: delivery_method
          });
        }

        handleFilters(filters); // always array
      }
    };
    return (
      <Box>
        <Typography variant='body1'>Apply Filters</Typography>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            display: 'flex',
            //justifyContent: 'space-between',
            gridTemplateColumns: 'repeat(3, 1fr)',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
            marginTop: 2,
            width: '700px',
            padding: '20px',
            boxSizing: 'border-box'
          }}
        >          {/* Status Filter */}
          <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
            <Typography variant='body1' sx={{ marginBottom: '2px', fontSize: '14px', color: 'rgb(128, 128, 128)' }}>Filter by Shipment Status</Typography>
            <Controller
              name='status'
              control={control}
              defaultValue=''
              render={({ field: { value, onChange } }) =>
                <Select
                  label='Select Status'
                  value={value}
                  onChange={(e) => {
                    onChange(e.target.value);
                  }}
                  sx={{ width: '100%', borderRadius: '4px', border: '1px solid #000' }}
                >
                  <MenuItem value=''></MenuItem>
                  {/* {Object.entries(orderStatus).map(([key, value]) => (
                    <MenuItem key={key} value={key}>{value}</MenuItem>
                  ))} */}
                  {Object.entries(shipmentStatuses).map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
          </Box>

          {/* Order Source Filter */}
          <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
            <Typography variant='body1' sx={{ marginBottom: '2px', fontSize: '14px', color: 'rgb(128, 128, 128)' }}>Filter by Order Source</Typography>
            <Controller
              name='orderSource'
              control={control}
              defaultValue=''
              render={({ field: { value, onChange } }) =>
                <Select
                  label='Select Order Source'
                  value={value}
                  onChange={(e) => {
                    onChange(e.target.value);
                  }}
                  sx={{ width: '100%', borderRadius: '4px', border: '1px solid #000' }}
                >
                  <MenuItem value=''></MenuItem>
                  {Object.entries(orderSource).map(([key, value]) => (
                    <MenuItem key={key} value={key}>{value}</MenuItem>
                  ))}
                </Select>
              }
            />
          </Box>

          {/* Payment Source Filter */}
          <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
            <Typography variant='body1' sx={{ marginBottom: '2px', fontSize: '14px', color: 'rgb(128, 128, 128)' }}>Filter by Payment Source</Typography>
            <Controller
              name='payMethod'
              control={control}
              defaultValue=''
              render={({ field: { value, onChange } }) =>
                <Select
                  label='Select Payment Source'
                  value={value}
                  onChange={(e) => {
                    onChange(e.target.value);
                  }}
                  sx={{ width: '100%', borderRadius: '4px', border: '1px solid #000' }}
                >
                  <MenuItem value=''></MenuItem>
                  {Object.entries(paymentSource).map(([key, value]) => (
                    <MenuItem key={key} value={key}>{value}</MenuItem>
                  ))}
                </Select>
              }
            />
          </Box>
          {/* Next Day Delivery Filter */}
          <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
            <Typography variant='body1' sx={{ marginBottom: '2px', fontSize: '14px', color: 'rgb(128, 128, 128)' }}> Delivery Type </Typography>

            <Controller
              name="delivery_method"
              control={control}
              render={({ field }) => (
                <Select
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  sx={{ width: '100%', borderRadius: '4px', border: '1px solid #000' }}
                >
                  <MenuItem value=''></MenuItem>
                  <MenuItem value="next_day_delivery">Next Day Delivery</MenuItem>
                  <MenuItem value="standard">Standard Delivery</MenuItem>
                  <MenuItem value="store_pickup">Store Pickup</MenuItem>
                </Select>
              )}
            />
          </Box>

          {/* Apply Filters and Cancel Button */}
          <Box sx={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '20px', gap: '10px', mt: 'auto' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ textTransform: 'capitalize', marginTop: '20px', backgroundColor: '#2b3f7a' }}
            >
              Apply Filters
            </Button>
            <Button
              onClick={handleResetFilters}
              sx={{ textTransform: 'capitalize', marginTop: '20px', color: 'primary.main' }}
            >
              Reset
            </Button>
            <Button
              onClick={handleCancel}
              sx={{ textTransform: 'capitalize', color: 'primary.main', marginTop: '20px' }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }
  const draftStatuses = {
    6: 'DRAFT',
    7: 'DRAFT_INVALIDATED'
  };
  const isDraftTab = ['6', '7'].includes(statusFromUrl);
  const shipmentStatuses = isDraftTab ? draftStatuses : allOrderStatuses;

  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px', alignItems: 'center' }}>
            <Typography variant='h4'>Orders</Typography>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              {totalCount} record(s) found
            </Typography>
          </Box>
          <Box sx={{ width: '40%', display: 'flex', margin: '10px', justifyContent: 'end', padding: '0px' }}>
            {userid !== 159 && userid !== 155 && userid !== 160 && (
              <>
                <BottomNavigation
                  showLabels
                  sx={{ padding: '0px', backgroundColor: '#2b3f7a', width: '25%', fontWeight: '600' }}>
                  <BottomNavigationAction sx={{ borderRadius: '0px', padding: '0px', color: '#ffffff' }} onClick={() => handleOrderCreate()} label="Create Order" />
                </BottomNavigation>
              </>
            )}

          </Box>
        </Box>

        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{
            width: '100%',
            display: 'flex',
            margin: '0px 30px',
            '& .MuiInput-input': {
              width: '375px !important',
              padding: '5px 10px !important'
            },
            '& .MuiSvgIcon-root': {
              paddingRight: '10px'
            },
            justifyContent: 'space-between'
          }}>

            <Input
              type='search'
              value={searchString}
              sx={{ border: '1px solid #2b3f7a', borderRadius: '20px', marginTop: '25px' }}
              endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()} />}
              placeholder='Search by ID,Email,Phone(without country code)'
              onChange={(e) => handleSearchChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
            />

            <Box sx={{ marginLeft: '15px' }}>
              {userChannels.length > 1 && (<ChannelDropDown channelData={channelData} handleChannelFilter={handleFilters} />)}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '15px' }}>
              <Typography variant='body1' sx={{ marginBottom: '2px', fontSize: '14px', color: 'rgb(128, 128, 128)' }}>
                Filter by Date Range
              </Typography>
              <Box sx={{ display: 'flex', gap: '7px' }}>
               <DatePicker
  selected={
    selectDate.fromDate instanceof Date &&
    !isNaN(selectDate.fromDate)
      ? selectDate.fromDate
      : null
  }
  onChange={handleFromDateChange}
  selectsStart
  startDate={selectDate.fromDate}
  endDate={selectDate.toDate}
  isClearable
  placeholderText="From Date"
/>

<DatePicker
  selected={
    selectDate.toDate instanceof Date &&
    !isNaN(selectDate.toDate)
      ? selectDate.toDate
      : null
  }
  onChange={handleToDateChange}
  selectsEnd
  startDate={selectDate.fromDate}
  endDate={selectDate.toDate}
  minDate={selectDate.fromDate}
  isClearable
  placeholderText="To Date"
/>
              </Box>

            </Box>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              '& .MuiButton-sizeSmall': {
                lineHeight: '30px !important'
              },
              '& .MuiDivider-root': {
                borderRightWidth: 'thin !important',
                borderColor: '#2b3f7a'
              }
            }}>
              <Button sx={globalStyles.listSubheaderIcons} onClick={() => setOpenFilters(true)}>
                <FilterAltIcon /> Filters <Divider orientation="vertical" flexItem sx={{ padding: '0px 10px' }} />
              </Button>
              <Modal
                open={openFilters}
                onClose={() => setOpenFilters(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={{ ...globalStyles.modalContainer, width: '730px', height: '260px', height: 'auto', maxHeight: '80vh', overflowY: 'auto' }}>
                  <OrderFilters />
                </Box>
              </Modal>
              <Button sx={globalStyles.listSubheaderIcons} onClick={handleColumnClick}>
                <SettingsIcon /> Columns <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }} /> <Divider orientation="vertical" flexItem sx={{ '& .MuiDivider-root': { borderRightWidth: 'normal' } }} />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorCol}
                open={columnsOpen}
                onClose={() => setColumnsOpen(false)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <FormControl>
                  <Box sx={{ margin: '10px 20px' }}>
                    <Typography>
                      {selectedHeaders.length} out of {allTableHeaders.length} visible
                    </Typography>
                  </Box>
                  <Box sx={{ width: '100%', borderTop: '1px solid #2b3f7a', borderBottom: '1px solid #2b3f7a', margin: '10px 20px', width: '92.5%' }}>
                    <FormGroup sx={{ display: 'grid', width: '100%', gridTemplateColumns: 'auto auto auto' }}>
                      {allTableHeaders.map((header) => {
                        if (header.id === 'id') {
                          return (
                            <FormControlLabel control={<Radio />} label={header.label} />
                          )
                        } else {
                          return (
                            <FormControlLabel control={
                              <Checkbox
                                //checked={findChecked(header.id, selectedHeaders)}
                                checked={header.checked}
                              />}
                              label={header.label}
                              onChange={(e) => handleGridColumns(header)}
                            />
                          )
                        }
                      })}
                    </FormGroup>
                  </Box>
                  <Box sx={{
                    display: 'flex', margin: '10px 20px', justifyContent: 'space-between !important',
                    '& .MuiButton-root': {
                      textTransform: 'capitalize',
                      color: globalStyles.colors.backgroundPrimary
                    }
                  }}
                  >
                    <Button onClick={() => resetTableHeaders()}>Reset</Button>
                    <Button onClick={() => setColumnsOpen(false)}>Cancel</Button>
                  </Box>
                </FormControl>
              </Menu>
              <Button sx={globalStyles.listSubheaderIcons} onClick={handleClick}>
                <FileUploadIcon /> Export <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }} />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                sx={{ padding: 2, borderRadius: 1, boxShadow: 3 }}

              >
                <FormControl component="fieldset" sx={{ padding: 2 }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="export-options"
                    value={exportFormat}
                    onChange={(e) => setExportFormat(e.target.value)}
                  >
                    <FormControlLabel value="csv" control={<Radio size='small' />} label="CSV" sx={{ marginBottom: 1 }} />
                    <FormControlLabel value="excel" control={<Radio size='small' />} label="Excel XML" sx={{ marginBottom: 1 }} />
                  </RadioGroup>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                    <Button onClick={handleClose} sx={{ textTransform: 'none', color: 'error.main' }}>Cancel</Button>
                    <Button onClick={handleExport} variant="contained"
                      sx={{ textTransform: 'none', backgroundColor: 'primary.main', color: 'white' }}>Export</Button>
                  </Box>
                </FormControl>
              </Menu>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box sx={{ margin: '20px 30px' }}>
            {console.log("filterArray  valll", filterArray)}
            {filterArray.some(filter => ['status', 'order_source', 'pay_method'].some(key => filter.startsWith(key))) && 'Filters: '}

            {filterArray.map((filter) => {
              const [type, ...value] = filter.split(':');
              let label = '';
              if (type === 'status') label = `Status: ${orderStatus[value.join(':')]}`;
              if (type === 'order_source') label = `Order Source: ${orderSource[value.join(':')]}`;
              if (type === 'pay_method') label = `Payment Source: ${paymentSource[value.join(':')]}`;
              //if (type === 'one_day_delivery_charge') { label = `Next Day Delivery: ${value[0] === '1' ? 'True' : 'False'}`; }
              if (type === 'delivery_method') {
                let deliveryMap = { next_day_delivery: 'NDD', standard: 'SD', store_pickup: 'SP' };
                label = `Delivery Type: ${deliveryMap[value[0]] || value[0]}`;
              }
              return label ? (
                <Typography variant='' sx={{ margin: '20px 30px' }} key={filter}>
                  {label}
                  {['status', 'order_source', 'pay_method', 'delivery_method'].includes(type) && (
                    <CancelIcon sx={{ fontSize: '15px', cursor: 'pointer', color: '#2b3f7a' }} onClick={() => clearFilterArray(type)} />
                  )}
                </Typography>
              ) : null;
            })}

          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mx: '30px', mt: 2, }}>
            <Tabs value={['6', '7'].includes(statusFromUrl) ? '7' : ''}
              //value={statusFromUrl || ""}
              onChange={(e, value) => {
                setLoading(true);
                setFilterArray(prev => prev.filter(f => !f.startsWith('status:'))
                );
                const params = new URLSearchParams();
                if (searchString) { params.set("search", searchString); }
                if (value) { params.set("status", value); }
                navigate(`/orders${params.toString() ? `?${params.toString()}` : ""}`);
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{ minHeight: '40px', '& .MuiTabs-indicator': { backgroundColor: '#2b3f7a', height: '3px' } }}>
              <Tab label="All Orders" value="" sx={{ textTransform: 'none', minHeight: '40px' }} />
              {/* <Tab label="Draft Orders" value="6" sx={{ textTransform: 'none', minHeight: '40px' }} /> */}
              <Tab label="Draft Orders" value="7" sx={{ textTransform: 'none', minHeight: '40px' }} />
            </Tabs>
            <Box sx={{ display: "flex", alignItems: "center", ml: 36, mt: 1, gap: 6, whiteSpace: "nowrap", }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: "#2b3f7a" }}>
                <strong>Delivery Type * :</strong> NDD (Next Day Delivery) | SD (Standard Delivery) | *SP (Store Pickup)
              </Typography>

              <Typography variant="body2" sx={{ fontWeight: 500, color: "#2b3f7a" }}>
                <strong>Additional Discount :</strong> *addlDisc
              </Typography>
            </Box>
          </Box>
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                <CircularProgress size={30} sx={{ color: "#2b3f7a" }} />
              </Box>
            )}
            <Table aria-label="simple table">
              <TableHead sx={{
                backgroundColor: globalStyles.colors.backgroundPrimary,
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                <TableRow>
                  {allTableHeaders.map((header) => {
                    if (header.checked) {
                      return (
                        <StyledTableCell align='center'>{header.label}</StyledTableCell>
                      )
                    }
                  })}
                  <StyledTableCell align='center'>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listData.map((order) => {
                  // console.log("orderData", order);
                  return (
                    <StyledTableRow id={order.id}>
                      {allTableHeaders.map((header) => {
                        if (header.checked) {
                          if (header.id === 'createdAt') {
                            return (
                              <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                            )
                          } else if (header.id === 'grandTotal') {
                            return (
                              <StyledTableCell align='center'>
                                {parseFloat(order[header.id]).toFixed(2)}
                              </StyledTableCell>
                            )
                          } else if (header.id === "order_status") {
                            const status = (order.order_status || "").toLowerCase();
                            const isStorePickup = order.delivery_method === "store_pickup";

                            // Store Pickup Orders
                            if (
                              isStorePickup &&
                              ["delivered"].includes(status)
                            ) {
                              return (
                                <StyledTableCell align='center'>
                                  Order Picked
                                </StyledTableCell>
                              );
                            }

                            // Existing Shipment Logic
                            if (status === "complete") {
                              return (
                                <StyledTableCell align='center'>
                                  Order Shipped
                                </StyledTableCell>
                              );
                            }

                            return (
                              <StyledTableCell align='center'>
                                {order.order_status}
                              </StyledTableCell>
                            );
                          } else if (header.id === "synced_to_vinculum" && order[header.id] === 0) {
                            return (
                              <StyledTableCell align='center'>
                                False
                              </StyledTableCell>
                            )
                          } else if (header.id === "synced_to_vinculum" && order[header.id] === 1) {
                            return (
                              <StyledTableCell align='center'>
                                True
                              </StyledTableCell>
                            )
                          } else if (header.id === "pay_method" && order[header.id] === "ONLINE") {
                            return (
                              <StyledTableCell align='center'>
                                DEBIT/CREDIT CARD
                              </StyledTableCell>
                            )
                          }
                          else if (header.id === 'isBundled') {
                            return (
                              <StyledTableCell align='center'>
                                {order[header.id] ? "True" : "False"}
                              </StyledTableCell>
                            )
                            // } else if (header.id === 'one_day_delivery_charge') {
                            //   return (
                            //     <StyledTableCell align='center'>
                            //       {Number(order[header.id]) > 0 ? "True" : "False"}
                            //     </StyledTableCell>
                            //   )
                          } else if (header.id === 'isDiscounted') {
                            return (
                              <StyledTableCell align='center'>
                                {Number(order.extra_discount) === 1 ? "True" : "False"}
                              </StyledTableCell>
                            );
                          } else if (header.id === 'delivery_method') {
                            const deliveryMap = { next_day_delivery: 'NDD', standard: 'SD', store_pickup: 'SP' };
                            return (
                              <StyledTableCell align='center'>
                                {deliveryMap[order?.delivery_method] || '-'}
                              </StyledTableCell>
                            );
                          }
                          else if (header.id === 'mobile') {
                            return (
                              <StyledTableCell align='center'>
                                {order[header.id] ? order[header.id] : "N/A"}
                              </StyledTableCell>
                            )
                          } else if (header.id === 'is_gift_product') {
                            return (
                              <StyledTableCell align='center'>
                                {order[header.id] ? "True" : "False"}
                              </StyledTableCell>
                            )
                          }
                          else {
                            return (
                              <StyledTableCell align='center'>
                                {order[header.id]}

                              </StyledTableCell>
                            )
                          }
                        }
                      })}
                      <StyledTableCell align='center'>
                        <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a' }} onClick={() => handleEditClick(order)} />
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {!loading && listData?.length === 0 && (
            <Box sx={{ margin: '20px 30px', padding: '40px', textAlign: 'center', borderRadius: '12px', backgroundColor: '#f9fafb', border: '1px solid #e5e7eb' }}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#2b3f7a', mb: 1 }}> No Result Found</Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                {searchString ? "Try adjusting your search or filters." : statusFilter.length > 0 ? "No orders available in this selected tab." : "There are no orders available."}
              </Typography>
            </Box>
          )}
        </Box>
        <Box sx={{ justifyContent: 'center' }}>
          <Pagination count={Math.ceil(totalCount / 50)} page={currentPage} onChange={handlePagination} />
        </Box>
      </List>
    </React.Fragment>
  )
}


export default OrderList;